import React, { Component } from "react";
import Clicker from "./Clicker.js";

class Header extends Component {
  state = {
    title: "Karen's React Counter",
  };
  render() {
    return (
      <div>
        <nav className=" header navbar navbar-dark bg-dark">
          <div className="container">
            <div className="row d-flex align-items-center justify-content-center m-auto text-center text-light text-bold text-uppercase p-3">
              <i className="fa fa-hand-pointer-o fa-4x text-white"></i>
              <h1>{this.state.title}</h1>
            </div>
          </div>
        </nav>
        <Clicker />
      </div>
    );
  }
}

export default Header;
